import { render, staticRenderFns } from "./CompanyProtocolUpsertModal.vue?vue&type=template&id=3771e709"
import script from "./CompanyProtocolUpsertModal.vue?vue&type=script&lang=js"
export * from "./CompanyProtocolUpsertModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyProtocolUpsertModal.vue?vue&type=style&index=0&id=3771e709&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports